import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  del,
  formDataPost,
  formDataPut,
  patch,
  post,
  put,
} from "helpers/api_helper"
import {
  GET_ALL_SALES_REPORTS,
  GET_BUSINESS_TAX_REPORTS,
  GET_LOYALTY_POINTS_REPORTS,
  GET_PAYMENTS_METHOD_REPORTS,
  GET_GIFT_CARD_REPORT,
  GET_PREMIUM_GIFT_CARD_REPORT,
  GET_WALLET_REPORT,
  GET_WALLET_TRANSFER_REPORT,
  GET_WALLET_PURCHASE_REPORT,
  GET_ALL_B2C_SALES_REPORTS,
  GET_ALL_B2C_SUMMARY_SALES_REPORTS,
} from "helpers/url_helper"

export const getAllSalesReports = createAsyncThunk(
  GET_ALL_SALES_REPORTS,
  async payload => {
    const response = await post(GET_ALL_SALES_REPORTS, payload)
    return response
  }
)

export const getAllB2CSalesReports = createAsyncThunk(
  GET_ALL_B2C_SALES_REPORTS,
  async payload => {
    const response = await post(GET_ALL_B2C_SALES_REPORTS, payload)
    return response
  }
)
export const getAllB2CSummarySalesReports = createAsyncThunk(
  GET_ALL_B2C_SUMMARY_SALES_REPORTS,
  async payload => {
    const response = await post(GET_ALL_B2C_SUMMARY_SALES_REPORTS, payload)
    return response
  }
)

export const getGiftcardReports = createAsyncThunk(
  GET_GIFT_CARD_REPORT,
  async payload => {
    const response = await post(GET_GIFT_CARD_REPORT, payload)
    return response
  }
)
export const getPremiumGiftcardReports = createAsyncThunk(
  GET_PREMIUM_GIFT_CARD_REPORT,
  async payload => {
    const response = await post(GET_PREMIUM_GIFT_CARD_REPORT, payload)
    return response
  }
)
export const getWalletdReports = createAsyncThunk(
  GET_WALLET_REPORT,
  async payload => {
    const response = await post(GET_WALLET_REPORT, payload)
    return response
  }
)
export const getWalletTransferReports = createAsyncThunk(
  GET_WALLET_TRANSFER_REPORT,
  async payload => {
    const response = await post(GET_WALLET_TRANSFER_REPORT, payload)
    return response
  }
)
export const getWalletPurchaseReports = createAsyncThunk(
  GET_WALLET_PURCHASE_REPORT,
  async payload => {
    const response = await post(GET_WALLET_PURCHASE_REPORT, payload)
    return response
  }
)
export const getPaymentMethodReports = createAsyncThunk(
  GET_PAYMENTS_METHOD_REPORTS,
  async payload => {
    const response = await post(GET_PAYMENTS_METHOD_REPORTS, payload)
    return response
  }
)

export const getBusinessTaxReports = createAsyncThunk(
  GET_BUSINESS_TAX_REPORTS,
  async payload => {
    const response = await post(GET_BUSINESS_TAX_REPORTS, payload)
    return response
  }
)

export const getLoyaltyPointsReports = createAsyncThunk(
  GET_LOYALTY_POINTS_REPORTS,
  async payload => {
    const response = await post(GET_LOYALTY_POINTS_REPORTS, payload)
    return response
  }
)
